const state = {
  loading: false,
  permissionsLoading: false,
  error: null,
  success: null,
  drawer: null,
  tenants: [],
};

export default {
  state,
};
